import React from 'react';
import { type SxProps, Typography } from '@mui/material';

interface DayNameTypographyProps {
  children: React.ReactNode;
  sx?: SxProps;
}

const DayNameTypography = ({ children, sx = {} }: DayNameTypographyProps) => (
  <Typography
    sx={{
      fontSize: '11px',
      fontWeight: 600,
      color: '#535976',
      letterSpacing: '0.5px',
      lineHeight: '14px',
      textTransform: 'uppercase',
      // eslint-disable-next-line @typescript-eslint/no-misused-spread
      ...sx,
    }}
  >
    {children}
  </Typography>
);

export default DayNameTypography;
